import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { TiTick } from 'react-icons/ti';
import plusIcon from '../../images/icons/plus_icon.svg';
import editIcon from '../../images/icons/editIcon.svg';
import trash from '../../images/icons/trash.svg';
import getPpeComponentList from './queries/getPpeComponentList';
import Header from '../common/Header';
import AddPPE from './AddPPE';
import deletePpeComponent from './queries/deletePpeComponent';
import ButtonComponent from '../common/ButtonComponent';
import SubHeader from '../common/SubHeader';
import ConfirmDelete from '../Modal/ConfirmDelete';
import SearchBar from '../common/SearchBar';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const CreatePPE = () => {
  const [modal, setModal] = useState(false);
  const [mode, setMode] = useState('add');
  const [deleteModal, setDeleteModal] = useState(false);
  const [search, setSearch] = useState('');
  const [ppeData, setppeData] = useState([]);
  const [items, setItems] = useState({
    ppeComponentMasterId: '',
    quantity: 1
  });
  const id = useParams();
  const policies = returnPolicies();
  const { isLoading: ppeComponentLoading, data: ppeDataAll } = getPpeComponentList({
    id: id?.itemId,
    searchCriteria: ''
  });

  useEffect(() => {
    setppeData(ppeDataAll?.data?.ppeComponentItems);
  }, [ppeDataAll]);

  const { mutate: deletePpeComponentNew } = deletePpeComponent();
  const columns = ['Component', 'Sizable', 'Quantity', 'Unit Price(INR)', 'Unit Price(USD)', 'Price(INR)', 'Price(USD)', 'action'];
  const handleEdit = (item) => {
    setMode('edit');
    setModal(true);
    setItems(item);
  };
  const handleSearch = (value) => {
    setSearch(value);
  };
  useEffect(() => {
    if (search?.length > 2) {
      const filtered = ppeDataAll?.data?.ppeComponentItems?.filter(
        (item) => item?.componentName?.toLowerCase().includes(search?.toLowerCase())
        );
      setppeData(filtered);
    } else {
      setppeData(ppeDataAll?.data?.ppeComponentItems);
    }
  }, [search]);
  const handleDelete = (item) => {
    setDeleteModal(true);
    setItems(item);
  };
  const confrimDelete = () => {
    deletePpeComponentNew(items?.componentId);
    setDeleteModal(false);
    setItems({ ppeComponentMasterId: '', quantity: 1 });
  };
const cancelModal = () => {
  setDeleteModal(false);
  setItems({ ppeComponentMasterId: '',
  quantity: 1
});
};
  const ppeId = useParams();
  return (
    <>
      {modal && (
        <AddPPE
          {...{
            modal,
            setModal,
            mode,
            setMode,
            items,
            setItems
          }}
        />
      )}
      {deleteModal && (
        <ConfirmDelete
          modal={deleteModal}
          setModal={setDeleteModal}
          handleDelete={confrimDelete}
          handleCancel={cancelModal}
          message="Delete"
          subMessage="This will remove the Component from the Rank and Gender Combination"
        />
      )}
      <Header headerName="PPE" currentPage="Component Mapping" parentPageLink={`/ppe/${id.ppeId}`} parentPage="PPE" />
      <div className="manning-wrapper">
        <SubHeader
          searchComponent={<SearchBar handleSearch={handleSearch} search={search} placeholder="Search Component (Minimum 3 characters)" additionalClassName="search-input-width" />}
          addButtonComponent={policies?.ppePolicies.canEdit && (
            <ButtonComponent
              handleClick={() => {
                setModal(true);
                setMode('add');
              }}
              name="Add new"
              icon={plusIcon}
            />
          )}
        />
        <div className="flex justify-between items-center">
          {ppeId ? (
            <div className="pb-2" style={{ gap: 40, display: 'flex', fontSize: 16, fontWeight: '600', wordWrap: 'break-word' }}>
              <div className="Rank" style={{ color: '#4A4A4A' }}>
                Rank:
                <span className="pl-4" style={{ color: '#565FBB', fontWeight: '700' }}>
                  {ppeDataAll?.data?.rankName}
                </span>
              </div>
              <div className="Rank" style={{ color: '#4A4A4A' }}>
                Gender:
                <span className="pl-4" style={{ color: '#565FBB', fontWeight: '700' }}>
                  {ppeDataAll?.data?.gender}
                </span>
              </div>
              <div className="Rank" style={{ color: '#4A4A4A' }}>
                PPE Kit Price (INR):
                <span className="pl-4" style={{ color: '#565FBB', fontWeight: '700' }}>
                  {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(ppeDataAll?.data?.totalPrice)}
                </span>
              </div>
              <div className="Rank" style={{ color: '#4A4A4A' }}>
                PPE Kit Price (USD):
                <span className="pl-4" style={{ color: '#565FBB', fontWeight: '700' }}>
                  {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(ppeDataAll?.data?.priceUsd)}
                </span>
              </div>
            </div>
          ) : (
            <div>No Data Found</div>
          )}
        </div>
        <div className="items-table-rebuild-wrap">
          <table className="items-table-rebuild">
            <thead>
              <tr className="">
                {columns.map((item) => (
                  <th className=" capitalize">{item}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ppeData?.length > 0 ? (
                <>
                  {ppeData?.map((item) => (
                    <tr key={item?.ppeComponentMasterId} className="">
                      <td title={item?.componentName}>
                        <label>{item?.componentName}</label>
                      </td>
                      <td className=" justify-center">
                        <label className="">{item?.sizable && <TiTick size={17} />}</label>
                      </td>
                      <td title={item?.quantity}>
                        <label>{item?.quantity}</label>
                      </td>
                      <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}>
                        <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}</label>
                      </td>
                      <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}>
                        <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}</label>
                      </td>
                      <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.componentTotalPrice)}>
                        <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.componentTotalPrice)}</label>
                      </td>
                      <td title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.componentPriceUsd)}>
                        <label>{Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.componentPriceUsd)}</label>
                      </td>
                      {policies?.ppePolicies.canEdit && (
                      <td className="ppe-table-action">
                        <button type="button" onClick={() => handleEdit(item)}>
                          <img src={editIcon} alt="EditIcon" title="Edit" className="action-icon w-6" />
                        </button>
                        <button type="button" onClick={() => handleDelete(item)}>
                          <img src={trash} alt="DeleteIcon" title="Delete" className="action-icon w-6" />
                        </button>
                      </td>
                      )}
                    </tr>
                  ))}
                </>
              ) : (
                !ppeComponentLoading && (
                  <tr>
                    <td colSpan="9" className="w-full">
                      No Data Found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CreatePPE;
